// extracted by mini-css-extract-plugin
module.exports = {"root":"EllipsizeBlock_root__1Vzwn","overlay":"EllipsizeBlock_overlay__1JgUf"};